import { apiGet, apiPost, apiDelete } from './dist/apiUtils';


const devMode = true;

export async function getLogCountWithFetch() {
  const result = await apiGet('/count');
  if (result.success) {
    console.log('Number of log entries:', result.data.count);
    return result.data.count;
  }
  return null;
}
  
export async function getCounter() {
  const count1 = await getLogCountWithFetch();
  if (count1 !== null) {
    return count1;
  }
  return "Error";
}


// Extended version with more metadata options
export async function sendUserMetadata() {
  if (!devMode) {
    const metadata = {
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      language: navigator.language,
      screen: {
        width: window.screen.width,
        height: window.screen.height,
        colorDepth: window.screen.colorDepth
      },
      location: {
        href: window.location.href,
        hostname: window.location.hostname,
        pathname: window.location.pathname
      },
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      // Additional optional metadata
      cookiesEnabled: navigator.cookieEnabled,
      platform: navigator.platform,
      connection: navigator.connection ? {
        effectiveType: navigator.connection.effectiveType,
        rtt: navigator.connection.rtt,
        downlink: navigator.connection.downlink
      } : null,
      referrer: document.referrer
    };

    await apiPost('/count', metadata);
  }
}

export async function loginUser(username, password) {
  const result = await apiPost('/login', { username, password });
  return {
    success: result.success,
    message: result.message,
    data: result.data
  };
}

export async function registerUser(username, password) {
  const result = await apiPost('/register', { username, password });
  return {
    success: result.success,
    message: result.message,
    data: result.data
  };
}

// Comment API functions
export async function getComments() {
  const result = await apiGet('/comments');
  return {
    success: result.success,
    message: result.message,
    comments: result.success ? (result.data.comments || []) : []
  };
}

export async function createComment(content, userId, parentId = null) {
  const result = await apiPost('/comments/create', {
    content,
    username: userId,
    parent_id: parentId
  });
  return {
    success: result.success,
    message: result.message,
    comment: result.success ? result.data.comment : null
  };
}

export async function upvoteComment(commentId) {
  const result = await apiPost('/comments/upvote', { comment_id: commentId });
  return {
    success: result.success,
    message: result.message,
    upvotes: result.success ? result.data.upvotes : null
  };
}

export async function deleteComment(commentId) {
  const result = await apiDelete('/comments/delete', { comment_id: commentId });
  return {
    success: result.success,
    message: result.message
  };
}

